export default __webpack_public_path__ + "static/media/team-card.4ca698f8.JPG";